export default function getThemeOptions({
  ulColor = '#FF4C4C',
  dlColor = '#32C77F',
  udColor = '#FF4C4C',
  ddColor = '#32C77F'
} = {}) {
  return {
    'default-l': {
      // 主色
      '--main-color-1': '#136EF2',
      '--main-color-2': '#DE2121',
      '--main-color-3': '#3881f7e6',

      // 字体
      '--font-color-1': '#222222',
      '--font-color-2': '#333333',
      '--font-color-3': '#778691',
      '--font-color-4': '#AAAAAA',
      '--font-color-5': '#778691',
      '--font-color-6': '#3881F7',
      '--font-color-7': '#A4B5C1',

      '--font-color-1-rgb': '34,34,34',
      '--font-color-2-rgb': '51,51,51',
      '--font-color-3-rgb': '119,119,119',
      '--font-color-4-rgb': '170,170,170',

      // 背景
      '--bg-color-1': 'transparent',
      '--bg-color-2': '#FFFFFF',
      '--bg-color-3': '#F8F9FA',
      '--bg-color-4': '#FFF4F4',
      '--bg-color-5': '#f7f7f7',
      '--bg-color-6': '#FFFFFF',
      '--bg-color-7': '#eff2f4',
      '--bg-color-8': '#eff2f47f',
      '--bg-color-9': '#eff2f47f',
      '--bg-color-10': '#E0EAFF',

      '--bg-color-1-rgb': '245,245,245',
      '--bg-color-2-rgb': '255,255,255',
      '--bg-color-3-rgb': '248, 249, 250',
      '--bg-color-4-rgb': '255, 244, 244',

      // 线条
      '--border-color-1': '#EBEBEB7F',
      '--border-color-2': '#E7E7E7',
      '--border-color-3': '#E5E7F2',
      '--border-color-4': '#EBEBEB',
      '--border-color-5': '#EBEBEB',
      '--border-color-6': '#D0DAEF',

      // splitline
      '--split-color': '#EBEBEB',

      // 涨跌色
      '--up-color': ulColor,
      '--down-color': dlColor,
      '--flat-color': '#778691',

      // 筛选色
      '--filter-border-color': '#5B5B74',

      // 图表颜色
      '--chart-tooltip-background-color': '#eff1fa'
    },

    'default-d': {
      // 主色
      '--main-color-1': '#136EF2',
      '--main-color-2': '#DE2121',
      '--main-color-3': '#3881f7e6',

      // 字体
      '--font-color-1': '#FFFFFF', // 已适配暗色
      '--font-color-2': '#FFFFFF', // 已适配暗色
      '--font-color-3': '#868A95', // 已适配暗色
      '--font-color-4': '#AAAAAA',
      '--font-color-5': '#868A95',
      '--font-color-6': '#3881F7',
      '--font-color-7': '#868A95',

      '--font-color-1-rgb': '34,34,34',
      '--font-color-2-rgb': '51,51,51',
      '--font-color-3-rgb': '119,119,119',
      '--font-color-4-rgb': '170,170,170',

      // 背景
      '--bg-color-1': '#151925', // 已适配暗色
      '--bg-color-2': '#151925', // 已适配暗色
      '--bg-color-3': '#1E2230', // 已适配暗色
      '--bg-color-4': '#FFF4F4',
      '--bg-color-5': '#1E2230', // 已适配暗色
      '--bg-color-6': '#2F3549', // 已适配暗色
      '--bg-color-7': '#1E2230', // 已适配暗色
      '--bg-color-8': '#2f3549', // 已适配暗色
      '--bg-color-9': '#1E22307f', // 已适配暗色
      '--bg-color-10': '#2F3549',

      '--bg-color-1-rgb': '245,245,245',
      '--bg-color-2-rgb': '255,255,255',
      '--bg-color-3-rgb': '248, 249, 250',
      '--bg-color-4-rgb': '255, 244, 244',

      // 线条
      '--border-color-1': '#0000004D', // 已适配暗色
      '--border-color-2': '#E7E7E7',
      '--border-color-3': '#868A95', // 已适配暗色
      '--border-color-4': '#000000',
      '--border-color-5': '#868A95',
      '--border-color-6': '#262E46',

      // splitline
      '--split-color': '#EBEBEB',

      // 涨跌色
      '--up-color': udColor,
      '--down-color': ddColor,
      '--flat-color': '#778691',

      // 筛选色
      '--filter-border-color': '#5B5B74',

      // 图表颜色
      '--chart-tooltip-background-color': '#eff1fa'
    },

    'dlzq-d': {
      // 主色
      '--main-color-1': '#136EF2',
      '--main-color-2': '#DE2121',
      '--main-color-3': '#3CEEC4',

      // 字体
      '--font-color-1': '#FFFFFF', // 已适配暗色
      '--font-color-2': '#FFFFFF', // 已适配暗色
      '--font-color-3': '#8F8F8F', // 已适配暗色
      '--font-color-4': '#AAAAAA',
      '--font-color-5': '#8F8F8F',
      '--font-color-6': '#3881F7',
      '--font-color-7': '#8F8F8F',

      '--font-color-1-rgb': '34,34,34',
      '--font-color-2-rgb': '51,51,51',
      '--font-color-3-rgb': '143,143,143',
      '--font-color-4-rgb': '170,170,170',

      // 背景
      '--bg-color-1': '#111111', // 已适配暗色
      '--bg-color-2': '#111111', // 已适配暗色
      '--bg-color-3': '#1F1F1F', // 已适配暗色
      '--bg-color-4': '#FFF4F4',
      '--bg-color-5': '#1F1F1F', // 已适配暗色
      '--bg-color-6': '#3E3E3E', // 已适配暗色
      '--bg-color-7': '#1F1F1F', // 已适配暗色
      '--bg-color-8': '#1F1F1F', // 已适配暗色
      '--bg-color-9': '#1E22307f', // 已适配暗色
      '--bg-color-10': '#1F1F1F',

      '--bg-color-1-rgb': '245,245,245',
      '--bg-color-2-rgb': '255,255,255',
      '--bg-color-3-rgb': '248, 249, 250',
      '--bg-color-4-rgb': '255, 244, 244',

      // 线条
      '--border-color-1': '#0000004D', // 已适配暗色
      '--border-color-2': '#E7E7E7',
      '--border-color-3': '#868A95', // 已适配暗色
      '--border-color-4': '#000000',
      '--border-color-5': '#868A95',
      '--border-color-6': '#262E46',

      // splitline
      '--split-color': '#EBEBEB',

      // 涨跌色
      '--up-color': udColor,
      '--down-color': ddColor,
      '--flat-color': '#778691',

      // 筛选色
      '--filter-border-color': '#5B5B74',

      // 图表颜色
      '--chart-tooltip-background-color': '#eff1fa'
    }
  }
}
